import SessionStorage from '../helpers/sessionStorage'
import LocalStorage from '../helpers/storage'

const userConsent = {

    currentEmail() {
        return SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
    },

    currentEmailIsLastConsentOnThisDevice() {
        const email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        const acceptConsent = LocalStorage.getItem('acceptConsent')
        return !!email && !!acceptConsent && email === acceptConsent
    },

    isRequiredToConsentOnThisDevice() {
        const email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        if (!email) {
            return false
        }
        if (userConsent.currentEmailIsLastConsentOnThisDevice()) {
            return false
        }
        if (userConsent.isEmailInAllAcceptedConsent(email).emailIn) {
            return false
        }
        // User is already connected, no need to consent again
        // Multi-accounts case, the consent is required only for the first account (user)
        if (LocalStorage.getItem('token')) {
            return false
        }
        return true
    },
    removeConsent(email) {
        userConsent.removeEmailFromAllAcceptedConsent(email)
        LocalStorage.removeItem('acceptConsent')
    },

    saveCurrentEmailAsLastConsentAcceptedOnThisDevice() {
        const email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        if (email) {
            LocalStorage.setItem('acceptConsent', email)
            // Do not add the email in the list of all accepted consents for the moment
            // Wait for the password validation and account creation done
            // userConsent.addEmailInAllAcceptedConsent(email)
        }
        return email
    },

    isEmailInAllAcceptedConsent(email) {
        const allAcceptedConsentString = LocalStorage.getItem('allAcceptedConsent') || '[]'
        try{
            const allAcceptedConsent = JSON.parse(allAcceptedConsentString)
            return {
                emailIn: allAcceptedConsent.includes(email),
                allAcceptedConsent
            }
        } catch(error){
            console.error(error)
            return {
                emailIn: false,
                allAcceptedConsent: []
            }
        }
    },

    addEmailInAllAcceptedConsent() {
        const email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)

        if (email) {
            const {emailIn, allAcceptedConsent} = userConsent.isEmailInAllAcceptedConsent(email)
            if (!emailIn) {
                allAcceptedConsent.push(email)
                LocalStorage.setItem('allAcceptedConsent', JSON.stringify(allAcceptedConsent))
            }
            LocalStorage.removeItem('acceptConsent')
        }
    },

    removeEmailFromAllAcceptedConsent(email) {
        if (email) {
            const {emailIn, allAcceptedConsent} = userConsent.isEmailInAllAcceptedConsent(email)
            if (emailIn) {
                const index = allAcceptedConsent.indexOf(email)
                allAcceptedConsent.splice(index, 1)
                LocalStorage.setItem('allAcceptedConsent', JSON.stringify(allAcceptedConsent))
            }
        }
    },

    // Check if the user has already accepted the consent
    // Two cases: it's the current acceptConsent email
    // or
    // the email is in the list of all accepted consents.
    // Take care that the list can be false if the user removed its account from another device.
    resetAcceptedConsentIfRequired() {
        const currentEmail = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        const acceptConsent = LocalStorage.getItem('acceptConsent')
        if (currentEmail && acceptConsent !== currentEmail) {
            const { emailIn } = userConsent.isEmailInAllAcceptedConsent(currentEmail)
            if (!emailIn) {
                LocalStorage.removeItem('acceptConsent')
            } else {
                LocalStorage.setItem('acceptConsent', currentEmail)
            }
        }
    }

}


export default userConsent

